import { User } from '../types';

// Simulation d'utilisateurs pour la démo
const mockUsers: (User & { password: string })[] = [
  {
    id: '1',
    email: 'admin@herminette.fr', 
    password: 'admin123',
    firstName: 'Younes',
    lastName: 'A.',
    role: 'admin',
    permissions: [],
    createdAt: '2024-01-01T00:00:00Z'
  },
  {
    id: '2',
    email: 'bureau@herminette.fr',
    password: 'bureau123',
    firstName: 'Louis',
    lastName: 'D.',
    role: 'responsable_bureau',
    permissions: [],
    createdAt: '2024-01-01T00:00:00Z'
  },
  {
    id: '3',
    email: 'equipe1@herminette.fr',
    password: 'equipe123',
    firstName: 'Thomas',
    lastName: 'A.',
    role: 'responsable_equipe',
    teamId: 'team-5',
    permissions: [],
    createdAt: '2024-01-01T00:00:00Z'
  },
  {
    id: '4',
    email: 'charpentier@herminette.fr',
    password: 'charpentier123',
    firstName: 'Luc',
    lastName: 'T.',
    role: 'charpentier',
    teamId: 'team-2',
    permissions: [],
    createdAt: '2024-01-01T00:00:00Z'
  },
  {
    id: '5',
    email: 'stagiaire@herminette.fr',
    password: 'stagiaire123',
    firstName: 'Yannis',
    lastName: 'D.',
    role: 'stagiaire',
    teamId: 'team-1',
    permissions: [],
    createdAt: '2024-01-01T00:00:00Z'
  }
];

class AuthService {
  async login(email: string, password: string): Promise<{ user: User; token: string }> {
    // Simulation d'appel API avec délai
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    const userWithPassword = mockUsers.find(u => u.email === email && u.password === password);
    
    if (!userWithPassword) {
      throw new Error('Email ou mot de passe incorrect');
    }
    
    const { password: _, ...user } = userWithPassword;
    const token = this.generateToken(user);
    
    return { user, token };
  }

  validateToken(token: string): User {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const user = mockUsers.find(u => u.id === payload.userId);
      if (!user) throw new Error('User not found');
      
      const { password: _, ...userData } = user;
      return userData;
    } catch (error) {
      throw new Error('Token invalide');
    }
  }

  private generateToken(user: User): string {
    const header = btoa(JSON.stringify({ alg: 'HS256', typ: 'JWT' }));
    const payload = btoa(JSON.stringify({ 
      userId: user.id,
      email: user.email,
      role: user.role,
      exp: Date.now() + 24 * 60 * 60 * 1000 // 24h
    }));
    const signature = btoa('mock-signature');
    
    return `${header}.${payload}.${signature}`;
  }

  async refreshToken(token: string): Promise<string> {
    const user = this.validateToken(token);
    return this.generateToken(user);
  }

  async logout(): Promise<void> {
    // Simulation d'appel API
    await new Promise(resolve => setTimeout(resolve, 500));
  }
}

export const authService = new AuthService();